import React from "react";
import { Link as RouterLink } from "react-router";
import { Link, Text } from "@flixbus/honeycomb-react";
import { routePaths } from "@/constants/routePaths";
import type { PlanningMonth } from "../../CostPanel.types";
import type { OpDataVariableOption } from "../../../../hooks/useOpDataCatalog";
import useOpDataVariableValues from "../../../../hooks/useOpDataVariableValues";
import ReferencedOpDataGrid from "./ReferencedOpDataGrid.component";
import sectionStyles from "./ReferencedOpDataSection.module.scss";

export interface ReferencedOpDataSectionProps {
  referencedOpDataVariables: OpDataVariableOption[];
  planningMonths: PlanningMonth[];
  line: string | null;
}

const tipLead =
  "Operational Data used in this formula. " +
  "Click Update to recalculate with the latest ";
const linkText = "Operational Data";

// Separate from InputsBody so its store/Apollo dependency (useOpDataVariableValues)
// only mounts when there are Operational Data variables to show.
const ReferencedOpDataSection: React.FC<ReferencedOpDataSectionProps> = ({
  referencedOpDataVariables,
  planningMonths,
  line,
}) => {
  const values = useOpDataVariableValues(
    line,
    referencedOpDataVariables,
    planningMonths,
  );

  return (
    <div className={sectionStyles.section}>
      <Text Elem="p" extraClasses={sectionStyles.tip}>
        {tipLead}
        {line ? (
          <Link
            RouterLink={RouterLink}
            to={`${routePaths.operationalData}?line=${encodeURIComponent(line)}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            {linkText}
          </Link>
        ) : (
          linkText
        )}
        {"."}
      </Text>
      <ReferencedOpDataGrid
        referencedOpDataVariables={referencedOpDataVariables}
        planningMonths={planningMonths}
        values={values}
      />
    </div>
  );
};

export default ReferencedOpDataSection;
